<template>
    <div id="roomList">
        <!-- <van-nav-bar title="房间列表" fixed placeholder left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
      <a @click="showSearch = !showSearch" slot="right">
        <i class="iconfont iconSearch"></i>
      </a>
    </van-nav-bar> -->
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" offset="100" @load="getList">
            <div class="body">
                <div class="card" v-for="(item,index) in list" :key="index" @click="$router.push({path:'/roomDetail',query:{id:item.id}})">
                    <p>
                        <span class="title">
                            <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{item.houseAddress}}</span>
                            | {{item.no}}
                        </span>
                    </p>
                    <p>
                        <span>户型：{{item.chamberNum||'-'}}室{{item.hallNum||'-'}}厅{{item.toiletNumber||'-'}}卫 {{item.totalAcreage}} ㎡</span>
                        <span :class="item.status==8?'theme-color':item.status>=5&&item.status<=7?'success-color':'color9'">{{roomStatusList[item.status-1]}} | {{statusReserveList[item.statusReserve-1]}}</span>
                    </p>
                    <p>
                        <span>
                            {{item.acreage}}㎡ | 朝{{towardList.find( d=>{return d.value == item.toward}).label}}
                            <span v-if="item.kitchen">| 厨房</span>
                            <span v-if="item.toilet">| 独卫</span>
                            <span v-if="item.balcony">| 阳台</span>
                        </span>
                        <span>{{item.price}}元</span>
                    </p>
                    <p>地址：{{item.communityAddress}}</p>
                </div>
            </div>
        </van-list>
        <div style="height:1.2rem"></div>
        <div class="btn">
            <van-button class="font1" type="primary" block @click="showSearch = !showSearch">筛选</van-button>
        </div>
        <transition name="van-fade">
            <div v-show="showSearch" class="search">
                <div class="field">
                    <div class="searchT">地址</div>
                    <van-field left-icon="wap-home-o" maxlength="20" v-model="listQuery.address" placeholder="地址" />
                </div>
                <div class="field field1">
                    <div class="searchT">类型</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.houseType == ''}" @click="listQuery.houseType = ''">全部</div>
                        <div :class="{'active':listQuery.houseType == 1}" @click="listQuery.houseType = 1">分散式</div>
                        <div :class="{'active':listQuery.houseType == 2}" @click="listQuery.houseType = 2">集中式</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">房间状态</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.statusList.length==0}" @click="listQuery.statusList = []">全部</div>
                        <div v-for="(item,index) in roomStatusList" :key="index" v-show="(index+1)!=7" :class="{'active':listQuery.statusList.indexOf(index+1)>-1}" @click="statusChange(index+1)">{{item}}</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">下定状态</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.statusReserve == ''}" @click="listQuery.statusReserve = ''">全部</div>
                        <div :class="{'active':listQuery.statusReserve == 2}" @click="listQuery.statusReserve = 2">已下定</div>
                        <div :class="{'active':listQuery.statusReserve == 1}" @click="listQuery.statusReserve = 1">未下定</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">出租方式</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.rentWay == ''}" @click="listQuery.rentWay = ''">全部</div>
                        <div :class="{'active':listQuery.rentWay == 1}" @click="listQuery.rentWay = 1">可整租</div>
                        <div :class="{'active':listQuery.rentWay == 2}" @click="listQuery.rentWay = 2">可合租</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">面积</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.minAcreage == ''&&listQuery.maxAcreage == ''}" @click="listQuery.minAcreage = '';listQuery.maxAcreage = ''">全部</div>
                        <div :class="{'active':listQuery.minAcreage == 0&&listQuery.maxAcreage ==20}" @click="listQuery.minAcreage = 0;listQuery.maxAcreage =20">0~20㎡</div>
                        <div :class="{'active':listQuery.minAcreage == 20&&listQuery.maxAcreage ==40}" @click="listQuery.minAcreage = 20;listQuery.maxAcreage =40">20~40㎡</div>
                        <div class="range">
                            <input type="number" v-model="listQuery.minAcreage" />
                        </div>
                        <div>
                            <input type="number" v-model="listQuery.maxAcreage" />
                        </div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">户型信息</div>
                    <div class="flex">
                        <!-- <div :class="{'active':listQuery.type == 1}" @click="listQuery.type = 1">全部</div> -->
                        <div :class="{'active':listQuery.kitchen == 1}" @click="listQuery.kitchen = (!listQuery.kitchen)/1">厨房</div>
                        <div :class="{'active':listQuery.toilet == 1}" @click="listQuery.toilet = (!listQuery.toilet)/1">独卫</div>
                        <div :class="{'active':listQuery.balcony == 1}" @click="listQuery.balcony = (!listQuery.balcony)/1">阳台</div>
                        <div :class="{'active':listQuery.bayWindow == 1}" @click="listQuery.bayWindow = (!listQuery.bayWindow)/1">飘窗</div>
                        <div :class="{'active':listQuery.optimization == 1}" @click="listQuery.optimization = (!listQuery.optimization)/1">优化间</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">朝向</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.toward == ''}" @click="listQuery.toward = ''">全部</div>
                        <div :class="{'active':listQuery.toward == 'E'}" @click="listQuery.toward = 'E'">东</div>
                        <div :class="{'active':listQuery.toward == 'S'}" @click="listQuery.toward = 'S'">南</div>
                        <div :class="{'active':listQuery.toward == 'W'}" @click="listQuery.toward = 'W'">西</div>
                        <div :class="{'active':listQuery.toward == 'N'}" @click="listQuery.toward = 'N'">北</div>
                    </div>
                </div>
                   <div class="field field1">
                    <div class="searchT">是否多人间</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.mrFlag == '1'}" @click="listQuery.mrFlag = '1'">是</div>
                        <div :class="{'active':listQuery.mrFlag == '0'}" @click="listQuery.mrFlag = '0'">否</div>
                      
                    </div>
                </div>
                <div style="height:1.2rem;"></div>
                <div class="bottom">
                    <van-button class="font5" type="default" @click="resetSearch">重置</van-button>
                    <van-button class="font5" type="primary" @click="searchConfirm">确定</van-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestRoomList } from "@/api";
import { accSub } from "@/utils";
export default {
    name: "roomList",
    data() {
        return {
            loading: false,
            finished: false,
            showSearch: false,
            listQuery: {
                address: "", //地址
                houseType: "", //类型
                statusList: [], //状态
                statusReserve: "", //下定状态
                rentWay: "", //出租方式
                kitchen: "", //厨房
                toilet: "", //独卫
                balcony: "", //阳台
                bayWindow: "", //飘窗
                optimization: "", //优化间
                toward: "", //E：东，S：南，W：西，N：北
                minAcreage: "", //面积下限
                maxAcreage: "", //面积上限
                mrFlag:"",
                pageSize: 10,
                pageNumber: 1,
            },
            list: [],
        };
    },
    computed: {
        ...mapState(["towardList", "roomStatusList", "statusReserveList"]),
    },
    activated() {
        this.listQuery.pageNumber = 1;
        this.finished = false;
        this.list = [];
        this.getList();
    },
    created() {},
    mounted() {},
    methods: {
        getList() {
            this.loading = true;
            requestRoomList(this.listQuery)
                .then((res) => {
                    if (this.finished) return;
                    res.data.records.forEach((d) => {
                        d.showTitle = false;
                    });
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.finished = true;
                });
        },
        statusChange(status) {
            let index = this.listQuery.statusList.indexOf(status);
            if (index > -1) {
                this.listQuery.statusList.splice(index, 1);
            } else {
                this.listQuery.statusList.push(status);
            }
        },
        resetSearch() {
            this.listQuery = {
                address: "", //地址
                houseType: "", //类型
                statusList: [], //状态
                statusReserve: "", //下定状态
                rentWay: "", //出租方式
                kitchen: "", //厨房
                toilet: "", //独卫
                balcony: "", //阳台
                bayWindow: "", //飘窗
                optimization: "", //优化间
                toward: "", //E：东，S：南，W：西，N：北
                minAcreage: "", //面积下限
                maxAcreage: "", //面积上限
                mrFlag:"",
                pageSize: 10,
                pageNumber: 1,
            };
            this.list = [];
            this.loading = false;
            this.finished = false;
            this.showSearch = false;
            this.getList();
        },
        searchConfirm() {
            this.loading = false;
            this.finished = false;
            this.listQuery.pageNumber = 1;
            this.showSearch = false;
            this.list = [];
            this.getList();
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    // padding-top: 0.001rem;
    font-size: 0.35rem;
    margin-top: 0.3rem;
    .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
            text-align: left;
            display: flex;
            justify-content: space-between;
            padding: 0 0.4rem;
            line-height: 0.8rem;
            span {
                height: 0.8rem;
            }
            .title {
                font-size: 0.35rem;
                font-weight: 600;
                height: auto;
                color: #000;
                // span {
                //     max-width: 4.5rem;
                //     vertical-align: top;
                //     overflow: hidden;
                //     display: inline-block;
                //     height: auto;
                //     text-overflow: ellipsis;
                // }
                // .ellipsis {
                //     white-space: nowrap;
                // }
            }
            .big {
                font-size: 0.4rem;
            }
        }
    }
    > .card:first-child {
        margin-top: 0;
    }
    .theme-color {
        color: $theme-color;
    }
    .success-color {
        color: $success-color;
    }
    .fail-color {
        color: $fail-color;
    }
    .color9 {
        color: $color9;
    }
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    // padding-top: 0.4rem;
    .field {
        padding: 0 0.7rem;
        .searchT {
            text-align: left;
            font-size: 0.41rem;
            font-weight: 600;
            color: #666666;
            margin: 0.4rem 0;
            // padding-left: 0.4rem;
        }
        /deep/.van-cell {
            border: 1px solid $border-color;
        }
        .flex {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding-left: 0.35rem;
            > div {
                margin: 0.2rem 0.35rem;
                width: 2.4rem;
                height: 0.8rem;
                line-height: 0.8rem;
                border: 1px solid $border-color;
                &.active {
                    border: 1px solid $theme-color;
                    color: $theme-color;
                }
                input {
                    width: 100%;
                    height: 95%;
                    border: none;
                    text-align: center;
                }
            }
            .range {
                position: relative;
                overflow: inherit;
                &::after {
                    content: "~";
                    position: absolute;
                    right: -0.5rem;
                    top: 0;
                }
            }
        }
    }
    .field1 {
        padding: 0;
        .searchT {
            padding: 0 0.7rem;
            margin: 0.3rem 0;
        }
    }
    .bottom {
        position: fixed;
        bottom: 0;
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
